import { SettingsFieldSelect, RequiredToggle } from 'apps/builder/components/settings/modal/shared'

export const PassFailField = ({
  guid,
  label,
  required,
  type='Single Choice',
  keyField,
}) => {

  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
        />

        <div className="toggles-group">
          <div className="toggle-wrapper">
            <RequiredToggle guid={guid} active={required} />
          </div>
        </div>
      </div>
    </>
  )
}
